import Swal from "sweetalert2";
import { type Component } from "vue";

export async function loadView(viewComponent: Promise<Component>) {
    return viewComponent.catch((e) => {
        console.error((e as Error).cause);

        Swal.fire({
            icon: "warning",
            title: "GAGAL MEMUAT HALAMAN",
            text: "Hal ini bisa terjadi karena adanya update pada aplikasi atau masalah pada jaringan internet.",
            confirmButtonText: "Muat Ulang Aplikasi",
        }).then(() => window.location.reload());
    });
}

export function canvasFlip(canvas: HTMLCanvasElement, width: number) {
    const ctx = canvas.getContext("2d")!;
    ctx.translate(width, 0);
    ctx.scale(-1, 1);
}

export function videoCapture(video: HTMLVideoElement, aspectRatio: number) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d")!;

    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;
    const videoAspectRatio = videoWidth / videoHeight;

    const desiredAspectRatio = aspectRatio;
    let canvasWidth, canvasHeight, cropX, cropY, cropWidth, cropHeight;

    if (videoAspectRatio > desiredAspectRatio) {
        canvasHeight = videoHeight;
        canvasWidth = videoHeight * desiredAspectRatio;
        cropX = (videoWidth - canvasWidth) / 2;
        cropY = 0;
        cropWidth = canvasWidth;
        cropHeight = canvasHeight;
    } else {
        canvasWidth = videoWidth;
        canvasHeight = videoWidth / desiredAspectRatio;
        cropX = 0;
        cropY = (videoHeight - canvasHeight) / 2;
        cropWidth = canvasWidth;
        cropHeight = canvasHeight;
    }

    canvas.width = cropWidth;
    canvas.height = cropHeight;

    context.drawImage(
        video,
        cropX,
        cropY,
        cropWidth,
        cropHeight,
        0,
        0,
        canvas.width,
        canvas.height,
    );

    const result = canvas.toDataURL();
    canvas.remove();

    return result;
}
